





































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { AddMemberRequest, ApiRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { OrgLocation, RxProvider } from '../../types/entity';
import { MemberProfile } from '../../types/response';
declare var google: any;

@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            status: '',
            businessCloseTime: '',
            address: {
                fullAddress: '',
                city: '',
                state: '',
                zip: '',
                landmark: '',
            },
        };
    },
    validations() {
    const validations = {
        fullName: {
            required,
        },
        email: {
            email,
        },
        phone: {
            regex: (phone: any) =>  MedTransGoConstants.PHONE_REGX.test(phone),
        },
        businessCloseTime: {
            required,
        },
        address: {
            fullAddress: {
                required,
            },
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    };
    if (this.$data.phone === '') {
        delete validations.phone.regex;
    }
    return validations;
    },
})
export default class UpdateRxProviderModal extends Vue {
    private show = false;
    private providerGoogleAddress: any;

    public mounted() {
        this.getRxProviderDetails(this.$route.params.id);
        this.getGoogleAddress();
    }

    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.providerGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('providerAddress1'), {
                types: ['geocode'],
            },
            );
            this.providerGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(
                    this.providerGoogleAddress,
                );
            });
        });
    }
    private async getRxProviderDetails(rxproviderId: any) {
        const response = await ObjectFactory.getRxProviderService().getRxProviderDetails(this.$store.state.serverUrl,
        rxproviderId);
        if (response.success && response.data) {
            const rxprovider = response.data;
            this.$data.fullName = rxprovider.fullname;
            this.$data.email = rxprovider.email;
            this.$data.phone = rxprovider.phone;
            this.$data.status = rxprovider.status;
            this.$data.address = rxprovider.address ? rxprovider.address : '';
            this.$data.businessCloseTime = rxprovider.businessCloseTime ? rxprovider.businessCloseTime : '';
            this.show = true;
        } else {
            CommonUtils.showError(response);
        }
    }

    /**
     * @author <Shraddha.K>
     * @description - update rxprovider
     * @param req {Request} - calls update rxprovider API
     * @param res {Response} - Express Response - success result
     * @returns rxprovider list
     * @throws InvalidRequestException if rxprovider not found already exists
     */
    private async updateRxProvider() {
        const rxproviderId = this.$route.params.id;
        const updateRxProviderRequest: RxProvider = {
            fullname: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            status: this.$data.status,
            address: this.$data.address,
            businessCloseTime: this.$data.businessCloseTime,
        };
        const response = await ObjectFactory.getRxProviderService().updateRxProvider(this.$store.state.serverUrl,
        rxproviderId, updateRxProviderRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_RX_PROVIDER'),
                title: 'Success!',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
        replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private close() {
        this.$router.back();
    }
}
